<section class="payment__method" *ngIf="content">
  <h2 class="payment__method--title">
    {{ titleText ? titleText : content.howToPay }}
  </h2>
  <div class="payment__method-wrapper">
    <label class="payment__method--card" *ngIf="!isPeriodic"
      [class.payment__method--card-selected]="selectedPaymentMethod === PaymentMethodType.BLIK"
      [attr.aria-expanded]="selectedPaymentMethod === PaymentMethodType.BLIK">
      <img src="assets/images/blik-active.png"
        alt="{{ content?.blik ?? ('EXTERNAL_PAYMENTS.CHOOSE_METHOD.blik' | translate) }}" />
      <div class="payment__method--card-input-box">
        <input class="tile__input" type="radio" name="payment-method-type" [(ngModel)]="selectedPaymentMethod"
          [value]="PaymentMethodType.BLIK" />
        <div class="payment__method--card-input-box-checkbox"></div>
        <span>{{ content.blik }}</span>
      </div>
    </label>

    <div class="payment__method--blik-code ic-input" *ngIf="!isPeriodic && env.FEATURE_TOGGLES.BLIK_LVL_ZERO"
      [class.payment__method--blik-code-show]="selectedPaymentMethod === PaymentMethodType.BLIK"
      [attr.aria-hidden]="selectedPaymentMethod !== PaymentMethodType.BLIK">
      <form [formGroup]="terms">
        <app-autopay-terms [formGroup]="terms" [controlName]="'autopayTerms'"
          class="payment__autopay-terms"></app-autopay-terms>
        @if(showIcTerms) {
        <app-form-checkbox class="payment__ic-terms" [formGroup]="terms" [formControlName]="'icTerms'"
          [inputId]="'IC_REG'" [errorList]="[{label: content.required, type: ['required']}]" [isRequired]="true"
          [label]="content.regulations" [bolded]="false"></app-form-checkbox>
        }
      </form>
      <label for="blik">{{ content.blickCode }}</label>
      <div class="input-flex">
        <input id="blik-mobile" type="text" [class.invalid]="checkIfBlikCodeIsInvalid()" [formControl]="blikCodeControl"
          [attr.aria-label]="content.blikPlaceholder" placeholder="{{ content.blikPlaceholder }}"
          [value]="blikCodeControl.value" [attr.title]="content.blikPlaceholder" />
        <div *ngIf="checkIfBlikCodeIsInvalid()" class="error-icon"></div>
      </div>
      <div class="error-description-container" *ngIf="checkIfBlikCodeIsInvalid()">
        <span class="error-description">
          {{ content.blikError }}
        </span>
      </div>
    </div>

    @if(!onlyBlik) {
    <label *ngIf="!isPeriodic" class="payment__method--card"
      [class.payment__method--card-selected]="selectedPaymentMethod === PaymentMethodType.E_CARD">
      <img class="tile__icon" src="assets/images/e-card.PNG"
        alt="{{ content?.transfer ?? ('EXTERNAL_PAYMENTS.CHOOSE_METHOD.transfer' | translate) }}" />
      <div class="payment__method--card-input-box">
        <input class="tile__input" type="radio" name="payment-method-type" [(ngModel)]="selectedPaymentMethod"
          [value]="PaymentMethodType.E_CARD" />
        <div class="payment__method--card-input-box-checkbox"></div>
        <span>{{ content.transfer }}</span>
      </div>
      <button type="button" class="tooltip-icon" aria-haspopup="true" aria-expanded="false"
        aria-describedby="paymentOptionsInfoEcard"
        [attr.aria-label]="content?.paymentOptionsInfoAria ? content.paymentOptionsInfoAria : ('EXTERNAL_PAYMENTS.CHOOSE_METHOD.PAYMENT_OPTIONS_INFO_ARIA' | translate)">
        i
      </button>
      <div class="tooltip-wrapper" id="paymentOptionsInfoEcard" role="tooltip">
        <img src="assets/images/payment-options.png"
          alt="{{ content?.paymentOptionsInfoAria ? content.paymentOptionsInfoAria : ('EXTERNAL_PAYMENTS.CHOOSE_METHOD.PAYMENT_OPTIONS_INFO_ARIA' | translate) }}" />
      </div>
    </label>

    <label class="payment__method--card" [class.payment__method--card-selected]="
          selectedPaymentMethod === PaymentMethodType.PAYMENT_CARD
        ">
      <img class="tile__icon" src="assets/images/payment-card.PNG"
        alt="{{ content?.card ?? ('EXTERNAL_PAYMENTS.CHOOSE_METHOD.card' | translate) }}" />
      <div class="payment__method--card-input-box">
        <input class="tile__input" type="radio" name="payment-method-type" [(ngModel)]="selectedPaymentMethod"
          [value]="PaymentMethodType.PAYMENT_CARD" />
        <div class="payment__method--card-input-box-checkbox"></div>
        <span>{{ content.card }}</span>
      </div>
      <button type="button" class="tooltip-icon" aria-haspopup="true" aria-expanded="false"
        aria-describedby="paymentOptionsInfoPaymentCard"
        [attr.aria-label]="content?.paymentOptionsInfoAria ? content.paymentOptionsInfoAria : ('EXTERNAL_PAYMENTS.CHOOSE_METHOD.PAYMENT_OPTIONS_INFO_ARIA' | translate)">
        i
      </button>
      <div class="tooltip-wrapper reverse" id="paymentOptionsInfoPaymentCard" role="tooltip">
        <img src="assets/images/payment-options.png"
          alt="{{ content?.paymentOptionsInfoAria ? content.paymentOptionsInfoAria : ('EXTERNAL_PAYMENTS.CHOOSE_METHOD.PAYMENT_OPTIONS_INFO_ARIA' | translate) }}" />
      </div>
    </label>
    }
  </div>
</section>

@if(isPeriodic) {
<form [formGroup]="terms">
  <app-autopay-terms [formGroup]="terms" [controlName]="'autopayTerms'"
    [paymentType]="'PAYMENT_CARD'"></app-autopay-terms>
</form>
}

<section class="payment__buttons" *ngIf="content">
  <ic-ghost-button *ngIf="showBackButton" [typeHTML]="'button'" (click)="backClick()"
    [type]="GhostButtonType.BIG_SECOND_RANK_FLEX" [showArrow]="true" [arrowLeft]="true" [width]="140">
    <span class="forwardSpan start-btn__label" [innerHtml]="content.backBtn"></span>
  </ic-ghost-button>
  <ic-ghost-button [typeHTML]="'button'" [disabled]="selectedPaymentMethod == null" appPreventDoubleClick
    (throttledClick)="onSubmit()" [type]="GhostButtonType.BIG_FIRST_RANK_FLEX" [showArrow]="true" [width]="140">
    <span class="forwardSpan start-btn__label" innerHtml="{{ payButtonText ? payButtonText : content.payBtn }}"></span>
  </ic-ghost-button>
</section>